import { IntlContext } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { DateUtil } from '@xengage/gw-portals-util-js';
import classNames from 'classnames';
import React, { useCallback, useContext } from 'react';
import messages from './OfferOfInsuranceComponent.messages';
import metadata from './OfferOfInsuranceComponent.metadata.json5';
import styles from './OfferOfInsuranceComponent.module.scss';

function OfferOfInsuranceComponent(props) {
    const { offer, bindData } = props;
    const intl = useContext(IntlContext);

    const getFormattedDate = useCallback(
        (date) => {
            return intl.formatDate(new Date(date), {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
            });
        },
        [intl]
    );

    const isPastDate = useCallback(
        (date) => {
            const today = new Date();
            const x = DateUtil.compareIgnoreTime(date, today)
            return (x < 0);
        },
        [DateUtil]
    );  

    const overrideProps = {
        // 2025-01-14 - Debra Frum - US25425 - CE - Offer Edit - 10 Pay
        //                           US25435 - CE - Renewal Offers
        // Display Payment Due and payment message in red font when past due
        offerOfInsuranceDueDateLabel: {
            className: isPastDate(bindData.paymentDueDate_TWIA)
                ? classNames(styles.dateLabel, styles.dateWarning)
                : styles.dateLabel
        },
        offerOfInsuranceDueDateValue: {
            content: getFormattedDate(bindData.paymentDueDate_TWIA),
            className: isPastDate(bindData.paymentDueDate_TWIA)
                ? styles.dateWarning
                : ''
        },
        offerOfInsuranceSubmissionMiddleMessage: {
            visible: offer.jobType_TWIA !== 'Renewal',
            className: isPastDate(bindData.paymentDueDate_TWIA)
                ? classNames(styles.paymentMessage, styles.dateWarning)
                : styles.paymentMessage
        },
        offerOfInsuranceRenewalMiddleMessage: {
            visible: offer.jobType_TWIA === 'Renewal',
            className: isPastDate(bindData.paymentDueDate_TWIA)
                ? classNames(styles.paymentMessage, styles.dateWarning)
                : styles.paymentMessage
       },
        offerOfInsuranceExirationDateValue: {
            content: getFormattedDate(offer.offerExpiration_TWIA)
        },
        offerOfInsuranceExpirationDate: {
            visible: offer.offerExpiration_TWIA !== undefined
        },
        offerOfInsuranceBottomMessage: {
            visible: offer.offerExpiration_TWIA !== undefined,
            className: styles.paymentMessage
        },
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers}
        />
    );
}

export default OfferOfInsuranceComponent;
